import React from 'react';
import AsyncListSKUs from './listskus/async';
import AsyncViewSKU from './viewsku/async';
import AsyncAddOrEditSKU from './addoreditsku/async';
import AsyncListLooks from './listlooks/async';
import AsyncViewLook from './viewlook/async';
import AsyncAddOrEditLook from './addoreditlook/async';
import AsyncListProducts from './listproducts/async';
import AsyncAddOrEditProduct from './addoreditproduct/async';
import AsyncViewProduct from './viewproduct/async';
import SingleColumnLayout from '../../components/layout/SingleColumnLayout';
import ProductLayout from '../../components/layout/ProductLayout';
import {Redirect} from 'react-router';
import {Trans} from 'react-i18next';

const parent1 = {
  title: <Trans i18nKey="p.webmodule.title">Online Service</Trans>,
  path: '/web-module',
};
const parent2Skus = {
  title: <Trans i18nKey="p.p.skus.title">SKUs</Trans>,
  path: '/products',
};
const parent2Looks = {
  title: <Trans i18nKey="p.p.looks.title">Looks</Trans>,
  path: '/products/list-looks',
};
const parent3Products = {
  title: <Trans i18nKey="p.p.products.title">Products</Trans>,
  path: '/products/list-products',
};
export default [
  <SingleColumnLayout
    exact
    key="a"
    path="/products/list-skus"
    component={AsyncListSKUs}
    title={
      <div className="tutorial-add-sku-look">
        <Trans i18nKey="p.p.listskus.title">SKUs</Trans>
      </div>
    }
    parents={[parent1]}
  />,
  <SingleColumnLayout
    exact
    key="b"
    path="/products/view-sku"
    component={AsyncViewSKU}
    title={<Trans i18nKey="p.p.viewsku.title">View SKU</Trans>}
    subtitle={<Trans i18nKey="p.p.viewsku.title">View SKU</Trans>}
    parents={[parent1, parent2Skus]}
  />,
  <ProductLayout
    exact
    key="c"
    path="/products/add-sku"
    component={AsyncAddOrEditSKU}
    title={
      <div className="tutorial-add-sku-look-create">
        <Trans i18nKey="p.p.addoreditsku.add.sku.title">Add SKU</Trans>
      </div>
    }
    parents={[parent1, parent2Skus]}
  />,
  <ProductLayout
    exact
    key="d"
    path="/products/edit-sku"
    component={AsyncAddOrEditSKU}
    title={<Trans i18nKey="p.p.addoreditsku.edit.sku.title">Edit SKU</Trans>}
    parents={[parent1, parent2Skus]}
  />,
  <SingleColumnLayout
    exact
    key="f"
    path="/products/list-looks"
    component={AsyncListLooks}
    title={<Trans i18nKey="p.p.listlooks.title">Looks</Trans>}
    parents={[parent1]}
  />,
  <ProductLayout
    exact
    key="g"
    path="/products/add-look"
    component={AsyncAddOrEditLook}
    title={<Trans i18nKey="p.p.addoreditlook.add.look.title">Add Look</Trans>}
    parents={[parent1, parent2Looks]}
  />,
  <ProductLayout
    exact
    key="h"
    path="/products/edit-look"
    component={AsyncAddOrEditLook}
    title={<Trans i18nKey="p.p.viewlook.title">Edit Look</Trans>}
    parents={[parent1, parent2Looks]}
  />,
  <ProductLayout
    exact
    key="i"
    path="/products/view-look"
    component={AsyncViewLook}
    title={<Trans i18nKey="p.p.addoreditlook.edit.look.title">View Look</Trans>}
    parents={[parent1, parent2Looks]}
  />,
  <SingleColumnLayout
    exact
    key="j"
    path="/products/list-products"
    component={AsyncListProducts}
    parents={[parent1]}
    title={
      <div className="tutorial-product-grouping-product-management">
        <Trans i18nKey="p.p.listproducts.title">Makeup Products</Trans>
      </div>
    }
  />,
  <SingleColumnLayout
    exact
    key="k"
    path="/products/add-product"
    component={AsyncAddOrEditProduct}
    title={
      <Trans i18nKey="p.p.addoreditproduct.add.product.title">
        Add Product
      </Trans>
    }
    parents={[parent3Products]}
  />,
  <SingleColumnLayout
    exact
    key="l"
    path="/products/edit-product"
    component={AsyncAddOrEditProduct}
    title={
      <Trans i18nKey="p.p.addoreditproduct.edit.product.title">
        Edit Product
      </Trans>
    }
    parents={[parent3Products]}
  />,
  <SingleColumnLayout
    exact
    key="i"
    path="/products/view-product"
    component={AsyncViewProduct}
    title={<Trans i18nKey="p.p.viewproduct.title">View Product</Trans>}
    parents={[parent3Products]}
  />,

  <Redirect key="e" exact from="/products" to="/products/list-skus" />,
];
